const websiteHome = resolve => {
    require.ensure(['@/views/website/home.vue'],
        () => {
            resolve(require('@/views/website/home.vue'))
        })
}
const websiteAbout = resolve => {
    require.ensure(['@/views/website/about.vue'],
        () => {
            resolve(require('@/views/website/about.vue'))
        })
}
const websiteRecruit = resolve => {
    require.ensure(['@/views/website/recruit.vue'],
        () => {
            resolve(require('@/views/website/recruit.vue'))
        })
}
const websiteQuestions = resolve => {
    require.ensure(['@/views/website/questions.vue'],
        () => {
            resolve(require('@/views/website/questions.vue'))
        })
}
const websiteCommunity = resolve => {
    require.ensure(['@/views/website/community.vue'],
        () => {
            resolve(require('@/views/website/community.vue'))
        })
}




const roustes = [
    {
        path: '/',
        name: 'websiteHome',
        component: websiteHome,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },
    {
        path: '/about',
        name: 'websiteAbout',
        component: websiteAbout,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },
    {
        path: '/recruit',
        name: 'websiteRecruit',
        component: websiteRecruit,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },
    {
        path: '/questions',
        name: 'websiteQuestions',
        component: websiteQuestions,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },
    // 小保书社区
    {
        path: '/community',
        name: 'websiteCommunity',
        component: websiteCommunity,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },


]




export default roustes


// WEBPACK FOOTER //
// ./src/router/website.js